import React, {memo} from 'react';
import {Button} from "react-bootstrap";
import {useHistory} from "react-router-dom";

function GutGemachtComponent() {
    /*
        Once the Report Link is retrieved, our web app redirects to respective URL.
     */
    let history = useHistory();

    const handleReportButtonClick = async () => {
        //let link = sessionStorage.getItem('link');
        localStorage.removeItem('annotationsData');
        localStorage.removeItem('showGutGemacht');
        //let tmp = window.location.protocol + '//' + window.location.host;
        //const pathname = link.replace(tmp, '');
        history.push("/analyserequestpage");

    };

    return (
        <>

            <div className="bg w3-black w3-display-container w3-text-white">
                <br/> <br/>
                <div className="w3-display-top">
                    <h1 className="w3-xxlarge w3-center">Gut gemacht!</h1>
                    <hr className="w3-border-grey" style={{margin: 'auto', width: '40%'}}/>
                    <br/> <br/>
                    <h1 className="w3-large w3-center">Die Analyse wurde erfolgreich veröffentlich.</h1>
                    <br/>
                    <h1 className="w3-large w3-center">Hier
                        der Link: <Button className="handwai-btn-pdfopen"
                                          onClick={handleReportButtonClick}>Report</Button>
                    </h1>
                </div>
            </div>

        </>
    )
}

export default memo(GutGemachtComponent);